<template>
  <header class="header">
    <nav class="nav">
      <div class="logo">
        <a class="menu-links" @click="$router.push({name: 'whoami'})" accesskey="h" title="PaperMod (Alt + H)">David E Lares S</a>
        <div class="logo-switches">
          <button @click="toggleStyle" accesskey="t" title="(Alt + T)">
              <svg id="moon" xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
              </svg>
              <svg id="sun" xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <circle cx="12" cy="12" r="5"></circle>
                  <line x1="12" y1="1" x2="12" y2="3"></line>
                  <line x1="12" y1="21" x2="12" y2="23"></line>
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                  <line x1="1" y1="12" x2="3" y2="12"></line>
                  <line x1="21" y1="12" x2="23" y2="12"></line>
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>
          </button>
        </div>
      </div>
      <ul id="menu">
        <li>
          <a class="menu-links" @click="$router.push({name: 'whoami'})">
            <span :class="{ active: $route.name === 'whoami' }">whoami</span>
          </a>
        </li>
        <li>
          <a class="menu-links" @click="$router.push({name: 'projects'})">
            <span :class="{ active: $route.name === 'projects' }">Projects</span>
          </a>
        </li>
        <li>
          <a class="menu-links" @click="$router.push({name: 'writings'})">
            <span :class="{ active: $route.name === 'writings' }">Posts</span>
          </a>
        </li>
        <li>
          <a class="menu-links" @click="$router.push({name: 'gists'})">
            <span :class="{ active: $route.name === 'gists' }">Gists</span>
          </a>
        </li>
        <li>
          <a class="menu-links" @click="$router.push({name: 'contact'})" title="Contact">
            <span :class="{ active: $route.name === 'contact' }">Contact</span>&nbsp;
          </a>
        </li>
      </ul>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'Intro',
  async mounted() {
    await this.checkingStyle()
  },
  methods: {
    async checkingStyle() {
      if (localStorage.getItem("pref-theme") === "dark") {
        document.body.classList.add('dark');
      } else if (localStorage.getItem("pref-theme") === "light") {
        document.body.classList.remove('dark')
      } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.body.classList.add('dark');
      }
    },
    async toggleStyle() {
      if (document.body.className.includes("dark")) {
        document.body.classList.remove('dark')
        localStorage.setItem("pref-theme", 'light')
      } else {
        document.body.classList.add('dark')
        localStorage.setItem("pref-theme", 'dark')
      }
    }
  }
}
</script>
